import { campaignQuery } from './googleRegistrationAttribution';

/** Forward the same bounded campaign allowlist used by registration links. */
export function withDemoCampaign(destination: string, campaign = ''): string {
  const url = new URL(destination);
  for (const [key, value] of new URLSearchParams(campaignQuery(campaign))) {
    if (!url.searchParams.has(key)) url.searchParams.set(key, value);
  }
  return url.toString();
}

/** Seeded product org. Daily reset. Not the /book/demo meeting page. */
export const PEEK_DEMO_ORIGIN = 'https://demo.bidmio.app';

const PEEK_LANG: Record<string, string> = {
  sk: 'sk',
  cs: 'cs',
  cz: 'cs',
  da: 'da',
  de: 'de',
  en: 'en',
};

/**
 * Hero peek link: muted text to the seeded org, locale query only.
 * Option B (§2.1) — `https://demo.bidmio.app/?lang={sk|cs|da|de|en}`.
 */
export function peekDemoUrl(language?: string | null, campaign = ''): string {
  const base = (language || 'en').toLowerCase().split(/[-_]/)[0] || 'en';
  const lang = PEEK_LANG[base] || 'en';
  return withDemoCampaign(`${PEEK_DEMO_ORIGIN}/?lang=${lang}`, campaign);
}

/**
 * Trade demo link: the same seeded host, opened on one industry pack
 * (`/demo?lang=sk&industry=electrician`). Unknown packs fall back to the
 * default demo on the app side.
 */
export function tradeDemoUrl(language: string | null | undefined, industry: string, campaign = ''): string {
  const base = (language || 'en').toLowerCase().split(/[-_]/)[0] || 'en';
  const lang = PEEK_LANG[base] || 'en';
  const query = new URLSearchParams({ lang, industry });
  return withDemoCampaign(`${PEEK_DEMO_ORIGIN}/demo?${query.toString()}`, campaign);
}
